import { Suspense } from "react";
import Box from "@mui/material/Box";
import { Outlet, useLocation } from "react-router-dom";
import RouteFallback from "../../app/routing/fallback/RouteFallback";
import TopProgressBar from "../../shared/components/patterns/TopProgressBar";
import { AppNavbar, MainContent, SideMenu } from "./components";
import {
  getAppLayoutBackgroundColor,
  useSidebarDarkMode,
} from "./useAppLayoutAppearance";

export default function AppLayout() {
  const location = useLocation();
  const sidebarDark = useSidebarDarkMode();
  const backgroundColor = getAppLayoutBackgroundColor(sidebarDark);

  return (
    <Box
      sx={{
        backgroundColor,
        display: "flex",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <TopProgressBar />
      <AppNavbar />
      <SideMenu />
      <MainContent>
        <Suspense fallback={<RouteFallback />}>
          <Box
            key={location.pathname}
            sx={{
              animation: "routeContentIn 120ms ease-out both",
              minWidth: 0,
              width: "100%",
              "@keyframes routeContentIn": {
                from: {
                  opacity: 0.92,
                  transform: "translateY(2px)",
                },
                to: {
                  opacity: 1,
                  transform: "translateY(0)",
                },
              },
              "@media (prefers-reduced-motion: reduce)": {
                animation: "none",
              },
            }}
          >
            <Outlet />
          </Box>
        </Suspense>
      </MainContent>
    </Box>
  );
}
